export const NOVOZYMES_GREEN = ' #c5da00';
export const NOVOZYMES_BLUE = ' #0f3e49';
export const NOVOZYMES_WHITE = ' #c5da00';
